import { fetchEldDataRequest, fetchEldDataSuccess, fetchEldDataFailure } from '../actions/dataActions';
import {
  fetchUserPostsRequest,
  fetchUserPostsSuccess,
  fetchUserPostsFailure,
  fetchEspPostsRequest,
  fetchEspPostsSuccess,
  fetchEspPostsFailure,
  fetchInvPostsRequest,
  fetchInvPostsSuccess,
  fetchInvPostsFailure,
  fetchAllPostsRequest,
  fetchAllPostsSuccess,
  fetchAllPostsFailure,
} from '../actions/postActions';
const isDevelopment = process.env.NODE_ENV === 'development';
const API_URL = isDevelopment
  ? process.env.REACT_APP_API_URL
  : 'https://eld-timer-backend-service.api.prod.sit.sys.odj.cloud/';

export const fetchEldData = () => {
  return async (dispatch) => {
    dispatch(fetchEldDataRequest());

    try {
      const response = await fetch(`${API_URL}eld`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      dispatch(fetchEldDataSuccess(data));
    } catch (error) {
      dispatch(fetchEldDataFailure(error));
    }
  };
};

export const fetchInitialPosts = (username) => {
  return async (dispatch) => {
    dispatch(fetchUserPostsRequest());

    try {
      const response = await fetch(`${API_URL}posts/${username}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const posts = await response.json();
      dispatch(fetchUserPostsSuccess(posts));
    } catch (error) {
      dispatch(fetchUserPostsFailure(error));
    }
  };
};

export const fetchEspPosts = () => {
  return async (dispatch) => {
    dispatch(fetchEspPostsRequest());

    try {
      const response = await fetch(`${API_URL}posts/esp`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const esps = await response.json();
      dispatch(fetchEspPostsSuccess(esps));
    } catch (error) {
      dispatch(fetchEspPostsFailure(error));
    }
  };
};

export const fetchInvPosts = () => {
  return async (dispatch) => {
    dispatch(fetchInvPostsRequest());

    try {
      const response = await fetch(`${API_URL}invoices`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const invs = await response.json();
      dispatch(fetchInvPostsSuccess(invs));
    } catch (error) {
      dispatch(fetchInvPostsFailure(error));
    }
  };
};

export const fetchAllPosts = () => {
  return async (dispatch) => {
    dispatch(fetchAllPostsRequest());

    try {
      const response = await fetch(`${API_URL}posts`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const allPosts = await response.json();
      dispatch(fetchAllPostsSuccess(allPosts));
    } catch (error) {
      dispatch(fetchAllPostsFailure(error));
    }
  };
};
